import { TaskItemStatus } from '../constants';
import { Task } from '../interfaces';

export const getNextLinearTask = (tasks: Task[]): Task | undefined =>
  tasks.find((task) => !task.status || task.status === TaskItemStatus.IN_PROGRESS);
